export class BaseActionDefinition {
  public name: string
  public description: string
  public idml: string
  public isVisible: string
  public canExecute: string
  public actionType: string
  public icon: string

  constructor(model: BaseActionDefinition) {
    this.name = model.name
    this.description = model.description
    this.idml = model.idml
    this.actionType = model.actionType
    this.isVisible = model.isVisible
    this.canExecute = model.canExecute
    this.icon = model.icon
  }
}
